<template>
  <c-footer class="justify-content-center">
    <p class="text-center">
      &copy; 2021 Warzywa Damian i Dominika Trójmiasto
      <br>
      Rokitnica, 83-021 Pruszcz Gdański
    </p>
  </c-footer>
</template>
<script>
export default {
  name: 'TheFooter'
}
</script>